export default class HTTPError extends Error {
    response;
    status;
    body;
    constructor(response, body) {
        super(typeof body === "string" ? body : body.message);
        this.response = response;
        this.status = response.status;
        if (typeof body == "object")
            this.body = body;
    }
    static async handleErrorResponse(res) {
        if (!res.ok) {
            try {
                throw new HTTPError(res, res.headers.get("x-reason") || "Something went wrong");
            }
            catch (e) {
                throw e;
            }
        }
    }
}
